// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoMessage_root__1vC4T","input":"VideoMessage_input__15qR6"};